import React, { useState, useEffect } from 'react';
import styles from './menuHome.module.scss';
import { TabBar } from 'antd-mobile';
import { createFromIconfontCN } from '@ant-design/icons';
import { ApiCore } from '../../api/index';
import Home from '../home';
import Patient from '../patient';
// import Cure from '../cure';
import Cure from '../tools';
import Personal from '../personal';
import utils from '../../utils/utils';
import Menus from './menu.json';
import tab_homepage_black from '../../static/images_ae/menuIcon/tab-homepage-black.png';
import tab_homepage_gray from '../../static/images_ae/menuIcon/tab-homepage-gray.png';
import home_active from '../../static/images_cso/home_active.png';
import home_unactive from '../../static/images_cso/home_unactive.png';
import patient_active from '../../static/images_cso/patient_active.png';
import patient_unactive from '../../static/images_cso/patient_unactive.png';
import cure_active from '../../static/images_cso/cure_active.png';
import cure_unactive from '../../static/images_cso/cure_unactive.png';
import personal_active from '../../static/images_cso/personal_active.png';
import personal_unactive from '../../static/images_cso/personal_unactive.png';

//设置阿里图库地址
const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_3398857_mcvnz8cwfxq.js'
});

const api = new ApiCore();


class AeMenuHome extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.state = {
            selectedTab: 'homepage',
            hideMenu: false,
            menuArr: []
        };
    }

    componentDidMount() {
        const urlParams = utils.getUrlParams();
        const tab = urlParams && urlParams.tab;
        tab && this.setState({
            selectedTab: tab
        });
        this.getMenus();
    }

    getMenus() {
        // api.getMenus({}, {}).then(res => {
        //     if (res.code + '' === '0') {
        //         const _data = res.data[0].children;
        //         this.setState({
        //             menuArr: _data
        //         })
        //     }
        // });
        const _data = Menus.data[0].children;
        this.setState({
            menuArr: _data
        }, () => {
            this.getDoctorInfo();
        })
    }

    getDoctorInfo() {
        api.getCsoDoctorInfo().then((res: any) => {
            if (res.code == 0) {
                this.setState({
                    doctorInfo: res.data || {}
                });
            }
        })
    }

    updateTab(tab: any) {
        this.setState({
            selectedTab: tab
        }, () => {
            window.history.replaceState({}, document.title, `#/cso/doctor/home?tab=${tab}`);
        });
    }

    menusRender() {
        const { menuArr, selectedTab } = this.state;
        const existIcon = {
            'homepage': <Home selectedTab={selectedTab} doctorInfo={this.state.doctorInfo} updateTab={this.updateTab.bind(this)} />,
            'patient': <Patient selectedTab={selectedTab} doctorInfo={this.state.doctorInfo} updateTab={this.updateTab.bind(this)} />,
            'cure': <Cure selectedTab={selectedTab} doctorInfo={this.state.doctorInfo} updateTab={this.updateTab.bind(this)} />,
            'personal': <Personal selectedTab={selectedTab} doctorInfo={this.state.doctorInfo} updateTab={this.updateTab.bind(this)} />,
        }
        if (!menuArr || (menuArr && menuArr.length === 0)) {
            return null;
        }
        return (
            <TabBar
                unselectedTintColor="#989898"
                tintColor="#8A7AFB"
                barTintColor="white"
                hidden={this.state.hideMenu}
            >
                {menuArr.map((item: any) => {
                    let iconView = item.icon;
                    let IconComponent: any = '';
                    let _icon = tab_homepage_gray;
                    let _selectedIcon = tab_homepage_black;
                    if (item.icon === 'homepage') {
                        _icon = home_unactive;
                        _selectedIcon = home_active;
                    } else if (item.icon === 'patient') {
                        _icon = patient_unactive;
                        _selectedIcon = patient_active;
                    } else if (item.icon === 'cure') {
                        _icon = cure_unactive;
                        _selectedIcon = cure_active;
                    } else if (item.icon === 'personal') {
                        _icon = personal_unactive;
                        _selectedIcon = personal_active;
                    }
                    if (existIcon[item.icon]) {
                        IconComponent = existIcon[item.icon];
                    } else {
                        IconComponent = item.icon;
                    }
                    if (this.state.selectedTab != item.icon) {
                        IconComponent = null;
                    }
                    return (
                        <TabBar.Item
                            icon={<img src={_icon} width="20" height="20" alt="" />}
                            selectedIcon={<img src={_selectedIcon} width="20" height="20" alt="" />}
                            title={<span style={{ color: this.state.selectedTab == item.icon ? '#13598C' : 'rgba(0,0,0,0.25)', fontSize: '13px' }}>{item.name}</span>}
                            key={item.icon}
                            selected={this.state.selectedTab === item.icon}
                            onPress={() => {
                                this.setState({
                                    selectedTab: item.icon
                                }, () => {
                                    window.history.replaceState({}, item.name, `#/cso/doctor/home?tab=` + item.icon);
                                });
                                document.title = item.name;
                            }}
                        >
                            {IconComponent}
                            {/* {
                                this.state.selectedTab == item.icon ? IconComponent : null
                            } */}
                        </TabBar.Item>
                    )
                })}
            </TabBar>
        )
    }

    render() {
        return (
            <div className={`${styles.ae_menu_home_content} ${this.state.hideMenu ? styles.hide_menu_btn : ''}`}>
                {
                    this.menusRender()
                }
            </div >
        )
    };
}
export default AeMenuHome;